import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Link,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Attachment from "../../../../../Components/Broker/Attachment/Attachment";
import BulkUploadForm from "../../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import PostQueryForm from "../../../../../Components/Common/PostQuerySP/PostQueryForm";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import "../../../../../formLayout.scss";
import NotesSection from "../../../../../Components/Broker/NotesSection/NotesSection";

function EndorsementDetailNomineeDetails() {
  const navigate = useNavigate();
  const [viewTabsStatus, setViewTabsStatus] = useState("overview");
  const [notesData, setNotesData] = useState<
    Array<{ name: string; date: Date; description: string }>
  >([]);
  const [attachment, setAttachment] = useState(true);
  const [uploadFile, setUploadFile] = useState(false);
  const [priorityStatus, setPriorityStatus] = useState("Pending");
  const [sectionStatus, SetSectionStatus] = useState<string>("personalDetails");
  const [subSection, setSubSection] = useState("memberdetails");
  const [postQueryForm, setPostQueryForm] = useState(false);
  const personalDetails = useRef(null);
  const endorsementInfo = useRef(null);
  const attatchmentsdetails = useRef(null);
  const memberdetails = useRef(null);
  const endorsementDetails = useRef(null);
  const scrollToSection = (elementRef: any) => {
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const handleClicks = (ref: any) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  const updateMasterState = (attrName: any, value: any) => {
    if (attrName === "notes_new_data") {
      setNotesData((notesData) => [
        ...notesData,
        { name: "Sahil", date: new Date(), description: value },
      ]);
    } else {
      attrName(value);
    }
  };
  const empGradeData = [
    { defaultOpen: true, sum_insured: "", emp_count: "", features: [] },
  ];
  const prioritystatusData = [
    { key: "Pending", value: "Pending" },
    { key: "Expired", value: "Expired" },
    { key: "Active", value: "Active" },
    { key: "Rejected", value: "Rejected" },
    { key: "Inprogress", value: "Inprogress" },
  ];
  const nominee_table_data = [
    {
      nominee_name: "dhami sahil",
      relation_employee_nominee: "Self",
      dob_nominee: "22-feb-1999",
      age_nominee: "24 Years",
      addition_type_nominee: "Regular Enrolment",
      date: "24-04-2023",
      time: "04:00 PM",
    },
    {
      nominee_name: "Sahil",
      relation_employee_nominee: "Self",
      dob_nominee: "22-feb-1999",
      age_nominee: "24 Years",
      addition_type_nominee: "Regular Enrolment",
      date: "24-04-2023",
      time: "04:00 PM",
    },
  ];
  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate("/homebroker?page=endorsement");
            }}
          >
            <ChevronLeftIcon />
          </Link>
          <span className="detailIcon">E</span>
          <div>
            <h3>Endorsement - Nominee Details - Dependant</h3>
            <p>END 2342</p>
          </div>
        </Grid>
        <Grid
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          {/* Status Dropdown */}
          <div id={priorityStatus}>
            <div className="status_dropdown" id={priorityStatus}>
              {priorityStatus === "Highest" || priorityStatus === "Active" ? (
                <CheckCircleIcon id={priorityStatus} />
              ) : priorityStatus == "" || priorityStatus === "Rejected" ? (
                <CancelIcon id={priorityStatus} />
              ) : priorityStatus == "Pending" ? (
                <HourglassTopIcon id={priorityStatus} />
              ) : priorityStatus == "Inprogress" ? (
                <PublishedWithChangesIcon id={priorityStatus} />
              ) : priorityStatus == "Expired" ? (
                <HistoryToggleOffIcon id={priorityStatus} />
              ) : null}
              <SelectDropdown
                class_name="inputFieldd"
                title=""
                value={priorityStatus}
                attrName={setPriorityStatus}
                value_update={updateMasterState}
                dropdown_data={prioritystatusData}
                warn_status={false}
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection h-100">
              <Link
                className={
                  sectionStatus === "personalDetails"
                    ? "active sectionLink personalDetails"
                    : "sectionLink personalDetails"
                }
                onClick={() => {
                  scrollToSection(personalDetails);
                  SetSectionStatus("personalDetails");
                }}
              >
                <span> Member Info</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "memberdetails"
                        ? "inner_link active memberdetails"
                        : "inner_link memberdetails"
                    }
                    onClick={() => {
                      setSubSection("memberdetails");
                      handleClicks(subSection);
                      scrollToSection(memberdetails);
                    }}
                  >
                    Member & Policy Details
                  </Link>
                </li>
              </ul>
              <Link
                className={
                  sectionStatus === "endorsementInfo"
                    ? "active sectionLink endorsementInfo"
                    : "sectionLink endorsementInfo"
                }
                onClick={() => {
                  scrollToSection(endorsementInfo);
                  SetSectionStatus("endorsementInfo");
                }}
              >
                <span> Endorsement Info</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "endorsementDetails"
                        ? "inner_link active endorsementDetails"
                        : "inner_link endorsementDetails"
                    }
                    onClick={() => {
                      setSubSection("endorsementDetails");
                      handleClicks(subSection);
                      scrollToSection(endorsementDetails);
                    }}
                  >
                    Endorsement Details
                  </Link>
                </li>
              </ul>

              <Link
                className={
                  sectionStatus === "attatchmentsdetails"
                    ? "active sectionLink attatchmentsdetails"
                    : "sectionLink attatchmentsdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(attatchmentsdetails);
                  SetSectionStatus("attatchmentsdetails");
                }}
              >
                <span>Supporting Documents</span>
              </Link>
            </Grid>
            <Grid xs className="rightSection h-100">
              <Grid container spacing={3} alignItems="center">
                <Grid lg={7} md={7} xs={12} className="pl-0">
                  <div className="productTabs ">
                    <Button
                      className={
                        viewTabsStatus == "overview"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "overview");
                      }}
                    >
                      Overview
                    </Button>

                    <Button
                      className={
                        viewTabsStatus == "notes"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "notes");
                      }}
                    >
                      Notes
                    </Button>
                  </div>
                </Grid>
                <Grid
                  lg={5}
                  md={5}
                  xs={12}
                  style={{ textAlign: "right" }}
                  className="text-sm-center"
                >
                  <p className="lastupdate">
                    Last Update: 11:00AM, 25th July, 2023
                  </p>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid xs={12} className="p-0 mb-6">
                  <div className="client_info_section">
                    <p className="client_info_p empID md_width">
                      Client ID : <span>CL123</span>
                    </p>
                    <p className="client_info_p user md_width">
                      Member ID: <span>CL123</span>
                    </p>
                  </div>
                </Grid>
              </Grid>

              {viewTabsStatus == "overview" ? (
                <>
                  <Box className="detailSection" ref={personalDetails}>
                    <div className="sectionTitle">
                      <h4>Endorsement Info</h4>
                    </div>
                    <div ref={memberdetails}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Endorsement Details</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Endorsement Value"
                            value="Nominee Addition"
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Endorsement Type"
                            value="Non Commercial Endorsment"
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>

                  <Box className="detailSection" ref={endorsementInfo}>
                    <div className="sectionTitle">
                      <h4>Member Type Details</h4>
                    </div>
                    <div ref={endorsementDetails}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Member Type Info</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Member Type"
                            value="Dependant"
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Client"
                            value="EV001-ANC"
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Primary Employee"
                            value="EV001-ANC"
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>

                  <Box className="detailSection" ref={endorsementInfo}>
                    <div className="sectionTitle">
                      <h4>Personal Details</h4>
                    </div>
                    <div ref={endorsementDetails}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Basic Info</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Title"
                            value={"MR."}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="First Name"
                            value={"Sahil"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Last Name"
                            value={"Dhami"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Gender"
                            value={"Male"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Date of Birth"
                            value={"26/02/2000"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Contact Us"
                            value={"9876543210"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Relationship with Employee"
                            value={"Son"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Email"
                            value={"demo@gmail.com"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Professional Details</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Location"
                            value={"Registered Office"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Organisation Employee ID"
                            value={"EMP1234"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Department"
                            value={"Frontend"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Designation"
                            value={"Associate Developer"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Salary"
                            value={"₹ 500000"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Salary Bracket"
                            value={"1,00,000 - 10,00,000"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Date of Joining"
                            value={"23/05/07"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Official Email"
                            value={"demo@gmail.com"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Office Contact Number"
                            value={"9876543210"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>

                  <Box className="detailSection" ref={endorsementInfo}>
                    <div className="sectionTitle">
                      <h4>Address Details</h4>
                    </div>
                    <div ref={endorsementDetails}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">
                            Personal Address Details
                          </h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Building/Street Name"
                            value={"#6, Building"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Area Name"
                            value={"Area details will be here"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Country"
                            value={"India"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextField
                            class_name="inputField"
                            title="State"
                            value={"Punjab"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextField
                            class_name="inputField"
                            title="City"
                            value={"Mohali"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Pincode"
                            value={"123456"}
                            attrName={""}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>

                  <Box className="detailSection mt-4">
                    <div className="sectionTitle">
                      <h4>Policies Details</h4>
                    </div>
                    <Box className="employee_detailpolicy">
                      {empGradeData.map((data, index) => (
                        <Accordion
                          expanded={true}
                          className="Accordion_section employee_policiesSection accordion_padding"
                          // onChange={handleChange("panel1")}
                          defaultExpanded={data.defaultOpen}
                        >
                          <Grid container spacing={0}>
                            <Grid xs={12} className="px-0">
                              <AccordionSummary
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                style={{
                                  display: "inline-block",
                                  width: "100%",
                                  padding: "0",
                                }}
                              >
                                <Typography
                                  className="title"
                                  style={{ width: "100%" }}
                                >
                                  <Grid
                                    container
                                    spacing={3}
                                    style={{ paddingLeft: "0" }}
                                  >
                                    <Grid xs={6}>
                                      <h5>PB265764</h5>
                                    </Grid>
                                    <Grid
                                      xs={6}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <h6>2 Members</h6> <h6>Group Health</h6>
                                      <h6>HDFC Ergo</h6>
                                    </Grid>
                                  </Grid>
                                </Typography>
                              </AccordionSummary>
                            </Grid>
                            {/* <Grid
                                                            xs={2}
                                                            style={{
                                                                alignSelf: "Center",
                                                                display: "flex",
                                                                justifyContent: "end",
                                                                padding: "0",
                                                            }}
                                                        >
                                                            <AccordionSummary
                                                                expandIcon={<ExpandMoreIcon />}
                                                                aria-controls="panel1a-content"
                                                                id="panel1a-header"
                                                                style={{ paddingRight: "0" }}
                                                            >
                                                                <Typography></Typography>
                                                            </AccordionSummary>
                                                        </Grid> */}
                          </Grid>
                          <AccordionDetails style={{ padding: "0" }}>
                            <Grid container spacing={3}>
                              <Grid xs={12} className="policies_detail">
                                <div>
                                  <h4>
                                    Policy Number
                                    <span>PB265764</span>
                                  </h4>
                                </div>
                                <div>
                                  <h4>
                                    Sum Insured <span>₹ 5 00 000</span>
                                  </h4>
                                </div>
                                <div>
                                  <h4>
                                    Start Date <span>20-04-2023</span>
                                  </h4>
                                </div>
                                <div>
                                  <h4>
                                    End Date <span>20-04-2024</span>
                                  </h4>
                                </div>
                                <div>
                                  <h4>
                                    Insurer Name<span>HDFC Ergo</span>
                                  </h4>
                                </div>
                                <div>
                                  <h4>
                                    Product Type <span>Group Health</span>
                                  </h4>
                                </div>
                                {/* <div>
                                                                    <Link  className="networkhosplist">
                                                                        Network Hospital List
                                                                    </Link>
                                                                </div> */}
                              </Grid>
                            </Grid>
                            {/* <Grid container spacing={3}>
                                                            <Grid xs={6}>
                                                                <h4 className="subHeading">Member Details</h4>
                                                            </Grid>
                                                        </Grid> */}

                            {/* member section */}
                            {/* <Grid container spacing={3}>
                                                            <Grid xs={12}>
                                                                <div className="employeeDetailtable">
                                                                    <div className="employeePolicy_table" style={{ minWidth: "unset" }}>
                                                                        <ul className="heading">
                                                                            <li style={{ minWidth: "unset" }}>Member ID </li>
                                                                            <li style={{ minWidth: "unset" }}>Member Type</li>
                                                                            <li style={{ minWidth: "unset" }}>Member Name</li>
                                                                            <li style={{ minWidth: "220px" }}>Relationship with Employee</li>
                                                                            <li style={{ minWidth: "unset" }}>DOB</li>
                                                                            <li style={{ minWidth: "unset" }}>Age</li>
                                                                            <li style={{ minWidth: "220px" }}>Addition/Removal Type</li>
                                                                            <li style={{ minWidth: "unset" }}>Enrolment Date</li>
                                                                            <li style={{ minWidth: "unset" }}>Enrolment Time</li>
                                                                        </ul>

                                                                        {member_table_data.map((data, index) => (
                                                                            <ul className="subheading">
                                                                                <li style={{ minWidth: "unset" }}>{data.member_id}</li>
                                                                                <li style={{ minWidth: "unset" }}>{data.member_type}</li>
                                                                                <li style={{ minWidth: "unset" }}>{data.member_name}</li>
                                                                                <li style={{ minWidth: "220px" }}>{data.relation_employee}</li>
                                                                                <li style={{ minWidth: "unset" }}>{data.dob}</li>
                                                                                <li style={{ minWidth: "unset" }}>{data.age}</li>
                                                                                <li style={{ minWidth: "220px" }}>{data.addition_type}</li>
                                                                                <li style={{ minWidth: "unset" }}>{data.enrollment_date}</li>
                                                                                <li style={{ minWidth: "unset" }}>{data.enrollment_time}</li>
                                                                            </ul>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </Grid>
                                                        </Grid> */}

                            {/* nominee section */}
                            <Grid container spacing={3}>
                              <Grid xs={6}>
                                <h4 className="subHeading">Nominee Details</h4>
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              <Grid xs={12}>
                                <div className="employeeDetailtable">
                                  <div
                                    className="employeePolicy_table"
                                    style={{ minWidth: "unset" }}
                                  >
                                    <ul className="heading">
                                      <li>Nominee Name</li>
                                      <li>Relationship with Employee</li>
                                      <li>DOB</li>
                                      <li>Age</li>
                                      <li>Addition/Removal Type</li>
                                      <li>Date</li>
                                      <li>Time</li>
                                    </ul>

                                    {nominee_table_data.map((data, index) => (
                                      <ul className="subheading">
                                        <li>{data.nominee_name}</li>
                                        <li>
                                          {data.relation_employee_nominee}
                                        </li>
                                        <li>{data.dob_nominee}</li>
                                        <li>{data.age_nominee}</li>
                                        <li>{data.addition_type_nominee}</li>
                                        <li>{data.date}</li>
                                        <li>{data.time}</li>
                                      </ul>
                                    ))}
                                  </div>
                                </div>
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      ))}
                    </Box>
                  </Box>

                  <Box className="detailSection" ref={attatchmentsdetails}>
                    <div className="sectionTitle">
                      <h4>Supporting Documents </h4>
                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => setUploadFile(true)}
                        >
                          Add Document
                        </Link>
                      </div>
                    </div>
                    <Attachment
                      open_status={attachment}
                      attrName={setAttachment}
                      value_update={updateMasterState}
                    />
                  </Box>
                </>
              ) : null}

              {viewTabsStatus == "notes" ? (
                <>
                  <Box className="detailSection">
                    <div className="sectionTitle">
                      <h4>Notes</h4>
                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => {
                            setPostQueryForm(true);
                          }}
                        >
                          Add Notes
                        </Link>
                      </div>
                    </div>
                    <NotesSection data={notesData} />
                  </Box>
                </>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />
      <PostQueryForm
        attrName={setPostQueryForm}
        open_status={postQueryForm}
        value_update={updateMasterState}
      />
    </Box>
  );
}
export default EndorsementDetailNomineeDetails;
